import { filterKeys } from '@nu-art/ts-common';
export const extractSearchResponse = (entry) => {
    return {
        reference: getCodableConcept(entry.resource.code),
        values: getComponents(entry.resource.component),
        issued: entry.resource.issued, // optional- when a recorded finding like BP measurement was taken
        recordedDate: entry.resource.recordedDate, // optional- when an infection, or alike, was recorded
        abatementDateTime: entry.resource.recordedDate, // optional- when an infection, or alike, started going away
        performedDateTime: entry.resource.performedDateTime, // optional- when a procedure had been performed
        clinicalStatus: entry.resource.clinicalStatus, // optional- seems to be a variable, active or inactive
        verificationStatus: entry.resource.verificationStatus, // optional- seems to be a variable, confirmed or refuted
        status: entry.resource.status, // optional- completed/cancelled/active/aborted/not-done
        reasonCode: getCodableConcept(entry.resource.reasonCode),
        performedPeriod: entry.resource.performedPeriod,
        bodySite: getCodableConcept(entry.resource.bodySite),
        issue: getCodableConcept(entry.resource.issue?.[0].details),
        severity: entry.resource.issue?.[0].severity,
        valueQuantity: getSystemValue(entry.resource.valueQuantity),
    };
};
/**
 * Note that all optional fields are most likely always-existing for a specific category, and not existing for most others.
 * Right now we don't yet have category-specific fields to extract for the specific categories that require it.
 */
export const FHIR_CreateRequest_Search_Extractor = async (response) => {
    return response.patient_data[0].entry?.map(extractSearchResponse);
};
export const getCodableConcept = (item) => (!item ? undefined : {
    text: item.text,
    coding: getSystemCoding(item?.coding)
});
export const getSystemCoding = (codes = []) => {
    return codes?.map((code) => filterKeys({
        refSystem: code?.system, // loinc/snomed
        refCode: code?.code, //
        text: code?.display, // label of variable
    }, 'text'));
};
export const getSystemValue = (code) => {
    if (!code)
        return undefined;
    return {
        refSystem: code.system, // loinc/snomed
        refCode: code.code, //
        value: code.value, // label of variable
    };
};
export const getComponents = (components) => {
    if (!components)
        return undefined;
    return components?.map(component => ({
        reference: {
            text: component.code?.text,
            coding: getSystemCoding(component.code.coding)
        },
        value: {
            refSystem: component.valueQuantity.system, // loinc/snomed
            refCode: component.valueQuantity.code, //
            value: component.valueQuantity.value, // value, e.g 120
        }
    }));
};
//# sourceMappingURL=search-extractor.js.map